<template>
  <div
    class="col-12 flex justify-center white-bg p3 md-px3 black"
  >
    <div class="col-12 md-col-8 flex flex-wrap ">
      <div class="col-6 flex flex-wrap items-center">
        <div class="flex flex-wrap">
          <span class="h3 bold">{{ wallet.holder.lastname }} {{ wallet.holder.firstname }} </span>
          <span v-if="wallet.center" class="col-12 h3"> {{ getCenterName(wallet.center) }}</span>
        </div>
      </div>
      <div class="col-6 flex justify-end items-center">
        <div style="width:107px" v-html="qrCode"> </div>
      </div>
    </div>
  </div>
</template>
<script>

import { generateQRcode, getCenterName } from '@/mixins/utils';

export default {
  props: { wallet: { type: Object } },
  setup (props) {
    const qrCode = generateQRcode(props.wallet.kezia_id);

    return { qrCode, getCenterName };
  }
};
</script>
<style>
.max-height-qrcode {
  width: 7vw;
}

.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

@media (max-width: 700px) {
  .max-height-qrcode {
    width: 25vw;
  }
}
</style>
